"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "2xl:container mx-auto" };
const _hoisted_2 = { class: "text-2xl pl-5 my-5 font-bold uppercase" };
const _hoisted_3 = { class: "flex flex-col md:flex-row my-3" };
const _hoisted_4 = { class: "flex items-center md:w-5/6 py-1 md:pl-3.5 mx-3" };
const _hoisted_5 = { class: "w-auto text-base md:pr-3.5" };
const _hoisted_6 = { class: "inline-flex items-start mr-2" };
const _hoisted_7 = { class: "inline font-bold uppercase text-base mr-2" };
const _hoisted_8 = { class: "inline font-bold uppercase text-base" };
const _hoisted_9 = { class: "flex grow w-auto md:justify-end md:pr-3.5 mx-3" };
const _hoisted_10 = ["disabled"];
const EndUserForm_vue_1 = __importDefault(require("./EndUserForm.vue"));
const vue_3 = require("vue");
const vue_router_1 = require("vue-router");
const BasicInformationsForm_vue_1 = __importDefault(require("./BasicInformationsForm.vue"));
const VehicleDataForm_vue_1 = __importDefault(require("./VehicleDataForm.vue"));
const ProductDataForm_vue_1 = __importDefault(require("./ProductDataForm.vue"));
const CustomerDataForm_vue_1 = __importDefault(require("./CustomerDataForm.vue"));
const Toggle_vue_1 = __importDefault(require("../../components/Form/Toggle.vue"));
const vehicleTypeStore_1 = require("../../stores/vehicleType/vehicleTypeStore");
const vehicleBrandStore_1 = require("../../stores/vehicleBrand/vehicleBrandStore");
const securityStore_1 = require("../../stores/security/securityStore");
const toastStore_1 = require("../../stores/toast/toastStore");
const Modal_vue_1 = __importDefault(require("../../components/Modal.vue"));
const GuaranteeProductReturnCreateRequest_1 = require("../../models/guaranteeProductReturn/GuaranteeProductReturnCreateRequest");
const i18n_1 = require("../../common/i18n");
const fetch_1 = __importDefault(require("../../common/utils/fetch"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'GuaranteeProductReturn',
    setup(__props) {
        const router = (0, vue_router_1.useRouter)();
        const securityStore = (0, securityStore_1.useSecurityStore)();
        const vehicleTypeStore = (0, vehicleTypeStore_1.useVehicleTypeStore)();
        const vehicleBrandStore = (0, vehicleBrandStore_1.useVehicleBrandStore)();
        const toastStore = (0, toastStore_1.useToastStore)();
        const guaranteeProductReturnCreateRequest = (0, vue_3.ref)(new GuaranteeProductReturnCreateRequest_1.GuaranteeProductReturnCreateRequest());
        const successfulSubmissionModalIsOpen = (0, vue_3.ref)(false);
        (0, vue_3.onBeforeMount)(() => {
            guaranteeProductReturnCreateRequest.value =
                new GuaranteeProductReturnCreateRequest_1.GuaranteeProductReturnCreateRequest();
            vehicleTypeStore.reset();
        });
        (0, vue_3.watchEffect)(() => {
            if (securityStore.authenticatedUser === null) {
                return;
            }
            guaranteeProductReturnCreateRequest.value.customer = securityStore.authenticatedUser
                .customer.iri;
        });
        (0, vue_3.watch)(() => guaranteeProductReturnCreateRequest.value.customerEqualsEndUser, () => {
            if (securityStore.authenticatedUser === null) {
                return;
            }
            if (guaranteeProductReturnCreateRequest.value.customerEqualsEndUser) {
                guaranteeProductReturnCreateRequest.value.endUserName =
                    securityStore.authenticatedUser.customer.name;
                guaranteeProductReturnCreateRequest.value.endUserZipCode =
                    securityStore.authenticatedUser.customer.zipCode;
                guaranteeProductReturnCreateRequest.value.endUserCity =
                    securityStore.authenticatedUser.customer.city;
                guaranteeProductReturnCreateRequest.value.endUserStreet =
                    securityStore.authenticatedUser.customer.street;
                guaranteeProductReturnCreateRequest.value.endUserMobile =
                    securityStore.authenticatedUser.customer.mobile;
                guaranteeProductReturnCreateRequest.value.endUserEmail =
                    securityStore.authenticatedUser.customer.email;
                return;
            }
            guaranteeProductReturnCreateRequest.value.endUserName = "";
            guaranteeProductReturnCreateRequest.value.endUserZipCode = "";
            guaranteeProductReturnCreateRequest.value.endUserCity = "";
            guaranteeProductReturnCreateRequest.value.endUserStreet = "";
            guaranteeProductReturnCreateRequest.value.endUserMobile = "";
            guaranteeProductReturnCreateRequest.value.endUserEmail = "";
        }, { deep: true });
        (0, vue_3.watch)(() => guaranteeProductReturnCreateRequest.value.vehicleType, (newValue, oldValue) => {
            var _a;
            if (newValue === oldValue) {
                return;
            }
            vehicleTypeStore.selectedVehicleType =
                (_a = vehicleTypeStore.vehicleTypes.find((vehicleType) => vehicleType["@id"] === newValue)) !== null && _a !== void 0 ? _a : null;
        });
        (0, vue_3.watch)(() => guaranteeProductReturnCreateRequest.value.vehicleBrand, (newValue, oldValue) => {
            var _a;
            if (newValue === oldValue) {
                return;
            }
            guaranteeProductReturnCreateRequest.value.vehicleModel = null;
            vehicleBrandStore.selectedVehicleBrand =
                (_a = vehicleBrandStore.vehicleBrands.find((vehicleBrand) => vehicleBrand["@id"] === newValue)) !== null && _a !== void 0 ? _a : null;
        });
        const submit = async () => {
            try {
                await createGuaranteeProductReturn(router, guaranteeProductReturnCreateRequest.value);
                guaranteeProductReturnCreateRequest.value.dataAccurate = false;
                successfulSubmissionModalIsOpen.value = true;
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
        };
        const createGuaranteeProductReturn = async (router, guaranteeProductReturnCreateRequest) => {
            const options = { body: JSON.stringify(guaranteeProductReturnCreateRequest), method: 'POST' };
            try {
                const response = await (0, fetch_1.default)(router.resolve({ name: 'admin_guarantee_product_returns_api' }).href, options);
                return response;
            }
            catch (error) {
                console.error("Error creating guarantee product return:", error);
                throw error;
            }
        };
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("title", "Create Guarantee Product Return", "guarantee_product_return")), 1),
                (0, vue_2.createVNode)(ProductDataForm_vue_1.default, {
                    "guarantee-product-return-create-request": guaranteeProductReturnCreateRequest.value
                }, null, 8, ["guarantee-product-return-create-request"]),
                (0, vue_2.createVNode)(BasicInformationsForm_vue_1.default, {
                    "guarantee-product-return-create-request": guaranteeProductReturnCreateRequest.value
                }, null, 8, ["guarantee-product-return-create-request"]),
                (0, vue_2.createVNode)(CustomerDataForm_vue_1.default, {
                    "guarantee-product-return-create-request": guaranteeProductReturnCreateRequest.value
                }, null, 8, ["guarantee-product-return-create-request"]),
                (0, vue_2.createVNode)(EndUserForm_vue_1.default, {
                    "guarantee-product-return-create-request": guaranteeProductReturnCreateRequest.value
                }, null, 8, ["guarantee-product-return-create-request"]),
                (0, vue_2.createVNode)(VehicleDataForm_vue_1.default, {
                    "guarantee-product-return-create-request": guaranteeProductReturnCreateRequest.value
                }, null, 8, ["guarantee-product-return-create-request"]),
                (0, vue_2.createElementVNode)("div", _hoisted_3, [
                    (0, vue_2.createElementVNode)("div", _hoisted_4, [
                        (0, vue_2.createElementVNode)("div", _hoisted_5, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("accurate_data", "The information provided in the notification is correct and can be passed on to the manufacturer", "guarantee_product_return")), 1),
                        (0, vue_2.createElementVNode)("div", _hoisted_6, [
                            (0, vue_2.createElementVNode)("div", _hoisted_7, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("accurate_data_no", "No", "guarantee_product_return")), 1),
                            (0, vue_2.createVNode)(Toggle_vue_1.default, {
                                class: "mx-3",
                                border: "",
                                valid: guaranteeProductReturnCreateRequest.value.isDataAccurate(),
                                "show-validity": true,
                                required: "",
                                modelValue: guaranteeProductReturnCreateRequest.value.dataAccurate,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((guaranteeProductReturnCreateRequest.value.dataAccurate) = $event))
                            }, null, 8, ["valid", "modelValue"]),
                            (0, vue_2.createElementVNode)("div", _hoisted_8, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("accurate_data_yes", "Yes", "guarantee_product_return")), 1)
                        ])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_9, [
                        (0, vue_2.createElementVNode)("button", {
                            type: "button",
                            disabled: !guaranteeProductReturnCreateRequest.value.isValid((0, vue_2.unref)(vehicleTypeStore).selectedVehicleType),
                            class: "!py-3 w-full md:w-auto inline-block btn btn-rounded btn-primary",
                            onClick: _cache[1] || (_cache[1] = ($event) => (submit()))
                        }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("submit", "Submit", "guarantee_product_return")), 9, _hoisted_10)
                    ])
                ]),
                (0, vue_2.createVNode)(Modal_vue_1.default, {
                    isOpen: successfulSubmissionModalIsOpen.value,
                    title: (0, vue_2.unref)(i18n_1.trans)('succeful_submission_modal_header', 'The submission of the warranty return form was successful.', 'guarantee_product_return'),
                    onClose: _cache[2] || (_cache[2] = ($event) => (successfulSubmissionModalIsOpen.value = false))
                }, {
                    default: (0, vue_2.withCtx)(() => [
                        (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("successful_submission_modal_body", "The registration of the warranty return request is in progress. If you would like to submit it for a different tire, you can do so with the previously provided information.", "guarantee_product_return")), 1)
                    ]),
                    _: 1
                }, 8, ["isOpen", "title"])
            ]));
        };
    }
});
